import LocalPhoneIcon from "@mui/icons-material/LocalPhoneOutlined";
import PeopleIcon from "@mui/icons-material/PeopleAltOutlined";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  accordionContent,
  weekdayData,
  weekendData,
} from "../../api/TerrifData";
import HoverButton from "../HoverButton";
import { GoogleSheetRedirection, WhatsappRedirection, callRedirectionNo } from "../../api/Redirection";


const DayDyanamicWrapper = ({ title, price, ListData, adult }) => {
  return (
    <Box sx={{ marginBottom: "40px", width: "100%" }}>
      <Grid2 sm={12}>
        <Typography
          sx={{
            textTransform: "uppercase",
            fontFamily: "ZapfHumnst BT",
            fontWeight: 400,
            color: "#181818",
            marginBottom: "10px",
            fontSize: {
              xs: "16px",
              sm: "32px",
            },
            lineHeight: {
              xs: "19.8px",
              sm: "39.61px",
            },
            letterSpacing: {
              xs: "0.05em",
              sm: "0.05em",
            },
            padding: { xs: "0px 18px", sm: "0px 18px" },
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: "1px",
            backgroundColor: "rgba(228, 202, 174, 1)",
            margin: "5px 0",
          }}
        />
        <Box
          display={"flex"}
          marginTop={3}
          alignItems={"center"}
          gap={{ xs: "5rem", sm: "5rem", md: "26rem" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "180px",
              padding: { xs: "0px 18px", sm: "0px 18px" },
            }}
          >
            <Typography
              sx={{
                display: { xs: "none", sm: "block" },
                fontFamily: "ZapfHumnst BT",
                fontSize: "20px",
                lineHeight: "24.76px",
                color: "#886F58",
              }}
            >
              Price
            </Typography>
            <Typography
              sx={{
                fontFamily: "Sora",
                fontWeight: 600,
                color: "#442A0B",
                fontSize: {
                  xs: "20px",
                  sm: "23px",
                },
                lineHeight: {
                  xs: "25.2px",
                  sm: "30.24px",
                },
                marginBottom: "1px",
              }}
            >
              {price}
              {"/"}
              <Typography
                component="span"
                sx={{
                  fontWeight: 400,
                  fontSize: {
                    xs: "11px",
                    sm: "16px",
                  },
                  lineHeight: {
                    xs: "13.86px",
                    sm: "20.16px",
                  },

                  color: "#000",
                }}
              >
                Per night
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontFamily: "Sora",
                fontSize: {
                  xs: "7px",
                  sm: "11px",
                  lg: "13px",
                },
                fontWeight: 300,
                color: "#442A0B",
                lineHeight: "26px",
                letterSpacing: "0.02em",
              }}
            >
              Inclusive all taxes and GST{" "}
            </Typography>
          </Box>
          <Box
            sx={{ display: "flex", flexDirection: "column", width: "135px" }}
          >
            <Typography
              sx={{
                fontFamily: "ZapfHumnst BT",
                fontSize: {
                  xs: "14px",
                  sm: "16px",
                  lg: "20px",
                },
                lineHeight: "24.76px",
                letterSpacing: "5%",
                color: "#886F58",
                display: "flex",
                gap: 1,
              }}
            >
              <PeopleIcon /> Occupancy
            </Typography>
            <Typography
              sx={{
                fontFamily: "Sora",
                fontWeight: 400,
                fontSize: {
                  xs: "14px",
                  sm: "16px",
                  lg: "20px",
                },
                lineHeight: "26px",
                letterSpacing: "1%",
                color: "#4D4D4D",
                display: "flex",
                gap: 1,
              }}
            >
              {adult}
              &nbsp;Adults
            </Typography>
          </Box>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={0.1}
          sx={{
            fontFamily: "Sora",
            fontWeight: 300,
            color: "rgba(42, 42, 42, 1)",
            letterSpacing: "1%",
            fontSize: {
              xs: "14px",
              sm: "16px",
              lg: "20px",
            },
            lineHeight: {
              xs: "24px",
              sm: "38px",
            },
            padding: { xs: "0px 18px", sm: "0px 18px", lg: "0px" },
          }}
        >
          {ListData.map((data, i) => (
            <li key={i}>{data}</li>
          ))}
        </Box>
      </Grid2>
    </Box>
  );
};


export const AccordionSection = ({ accordionContent }) => {
  const [expanded, setExpanded] = useState(false);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ padding: { xs: "0px 18px", sm: "0px 18px", lg: "0px" } }}>
      {accordionContent.map((accordion, index) => (
        <Accordion
          key={index}
          expanded={expanded === index}
          onChange={handleAccordionChange(index)}
          sx={{
            border: "1px solid rgba(228, 202, 174, 1)",
            marginBottom: "20px",
            boxShadow: "none",
          }}
        >
          <AccordionSummary
            expandIcon={
              <span style={{ color: "#B8772A", fontSize: "24px" }}>+</span>
            }
            sx={{
              fontFamily: "ZapfHumnst BT",
              fontSize: { xs: "18px", sm: "24px" },
              fontWeight: 400,
              color: "#181818",
            }}
          >
            {accordion.title}
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                // Apply grid layout only for "COMMON AMENITIES"
                display: accordion.title === "COMMON AMENITIES" ? "grid" : "block",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "1fr",
                  md: "1.5fr 1fr",
                },
                gap: "10px",
              }}
            >
              {accordion.points.map((point, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: accordion.title === "COMMON AMENITIES" ? "0" : "10px", // Remove marginBottom in grid
                  }}
                >
                  {point.icon ? (
                    <Box sx={{ marginRight: "10px" }}>{point.icon}</Box>
                  ) : (
                    <Typography
                      sx={{
                        marginRight: "10px",
                        fontSize: "16px",
                        color: "#4D4D4D",
                      }}
                    >
                      •
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      fontFamily: "Sora",
                      fontSize: { xs: "14px", sm: "16px" },
                      color: "#4D4D4D",
                    }}
                  >
                    {point.text || point}
                  </Typography>
                </Box>
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};
const TerrifStyle = {
  mainContainer: {
    width: "100%",
    maxWidth: "1440px",
    padding: { xs: "0 0px", md: "0 220px" },
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignProperty: "center",
  },
  suitsHolder: {
    width: { xs: "auto", sm: "auto", md: "100%", lg: "100%", xl: "100%" },
    textTransform: "uppercase",
    margin: { xs: "1rem 0", sm: "1rem 0" },
    padding: { xs: "0px 18px", sm: "0px 18px" },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    fontFamily: "ZapfHumnst BT",
    fontWeight: 400,

    backgroundColor: "#F7EEE6",
    height: { xs: "42px", sm: "75px" },
    lineHeight: {
      xs: "13.62px",
      sm: "34.66px",
    },
    fontSize: {
      xs: "12px",
      sm: "20px",
      lg: "28px",
    },
    letterSpacing: {
      xs: "0.02em",
      sm: "0.15em",
      md: "0.09em",
      lg: "0.1em"
    },
  },
};

const TariffPage = () => {
   
  const handleGoogleSheetClick = () => {
       window.open(GoogleSheetRedirection, "_blank");
    };

  const handleWhatsAppClick = () => {
        window.open(WhatsappRedirection, "_blank");
      };
    
  const handleCallClick = () => {
        window.open(callRedirectionNo, "_blank");
      };
  
    return (
    <Box sx={TerrifStyle.mainContainer}>
      {/* {/ Header /} */}
      <Box marginTop={{ xs: 4, md: 4 }}>
        <Typography sx={TerrifStyle.suitsHolder}>
          The Earthen Suite | The Tropical Suite | The Amber Suite
        </Typography>
      </Box>

      <Box
        display={"flex"}
        flexDirection={"column"}
        marginTop={{ xs: 2, md: 10 }}
      >
        <DayDyanamicWrapper
          title={"weekend"}
          price={"₹20,000"}
          ListData={weekendData}
          adult={2}
        />
        <DayDyanamicWrapper
          title={"weekdays"}
          price={"₹18,000"}
          ListData={weekdayData}
          adult={2}
        />
      </Box>

      {/* {/ Accordion Section /} */}
      <AccordionSection accordionContent={accordionContent} />
      {/* {/ Notes Section /} */}
      <Box mt={5} sx={{ padding: { xs: "0px 18px", sm: "0px 18px" } }}>
        <Typography
          sx={{
            fontFamily: "ZapfHumnst BT",
            fontSize: { xs: "16px", sm: "20px" },
            fontWeight: 400,
            color: "rgba(24, 24, 24, 1)",
            marginBottom: "10px",
          }}
        >
          NOTE
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: "1px",
            backgroundColor: "rgba(228, 202, 174, 1)",
            marginBottom: "10px",
          }}
        />
        <Typography
          sx={{
            fontFamily: "Sora",
            fontSize: { xs: "14px", sm: "16px" },
            fontWeight: 300,
            color: "rgba(42, 42, 42, 1)",
            textAlign: "left",
            margin: "20px 0",
          }}
        >
          Birthday and Anniversary decor can be requested at an additional cost.
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: "1px",
            backgroundColor: "rgba(228, 202, 174, 1)",
          }}
        />
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        gap={2}
        m="20px 0"
        justifyContent="space-between"
        flexWrap="nowrap"
        sx={{ padding: { xs: "0px 18px", sm: "0px 18px" } }}
      >
        <Box
          display="flex"
          gap={1.5}
          flexDirection={{ xs: "row-reverse", sm: "row" }}
          justifyContent="flex-start"
          width="auto"
        >
          <HoverButton
            onClick={handleGoogleSheetClick}
            btnText={"Check Availability"}
            width={{ xs: "100%", sm: "231px" }}
            fontWeight={"400"}
          />
          <HoverButton
            onClick={handleCallClick}
            btnText={<LocalPhoneIcon sx={{ marginTop: 1 }} />}
            width="50px"
            height="50px"
          />
        </Box>
        <Button
          onClick={handleWhatsAppClick}
          disableElevation
          disableRipple
          variant="contained"
          sx={{
            border: "1.5px solid #442A0B",
            color: "#fff",
            borderRadius: 0,
            backgroundColor: "#442A0B",
            padding: "8px 16px",
            width: { xs: "100%", sm: "278px" },
            fontWeight: "bold",
            fontSize: "16px",
            letterSpacing: "0.01em",
          }}
        >
          Book
        </Button>
      </Box>
    </Box>
  );
};

export default TariffPage;
